import { useState, useEffect } from 'react';

/**
 * Hook customizado para debounce de um valor.
 * @param value O valor a ser debounced.
 * @param delay O tempo de espera em milissegundos.
 * @returns O valor debounced.
 */
function useDebounce<T>(value: T, delay: number): T {
  // Estado para armazenar o valor debounced
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Configura um timeout para atualizar o valor debounced após o delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpa o timeout se o valor mudar (ou no desmonte)
    // Isso garante que o valor só seja atualizado se o usuário parar de digitar
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Re-executa apenas se o valor ou o delay mudarem

  return debouncedValue;
}

export default useDebounce; 